import React, { useState } from 'react'
import basiqBlueLogo from '../logo-basiq-blue.svg'
import basiqSelectBlueLogo from '../logo-basiq-select-blue.svg'
import classiqBlueLogo from '../logo-classiq-blue.svg'
import classiqSelectBlueLogo from '../logo-classiq-select-blue.svg'
import generiqBlueLogo from '../logo-generic-blue.svg'
import { PRODUCT_TYPES } from './Tabs'

const ContactForm = (props) => {
  const [formLoading, setFormLoading] = useState(false)
  const rate = {
    label: props.selectedRate.label,
    interestValue: props.selectedRate.interestValue,
    discount: props.selectedRate.discount,
    ltv: props.selectedRate.ltv,
    gewensteHypotheek: props.selectedRate.gewensteHypotheek,
    geschatteMarktwaarde: props.selectedRate.geschatteMarktwaarde,
    uniq: props.selectedRate.uniq,
  }

  console.log('ContactForm rate', rate)
  console.log('ContactForm props', props)

  const handleSubmit = (event) => {
    const token = process.env.REACT_APP_SAM_TOKEN
    setFormLoading(true)
    event.preventDefault()
    const contactObj = {
      intermediary_id: props.intermediary.id,
      name: event.target[0].value,
      email: event.target[1].value,
      phone: event.target[2].value,
      geschatteMarktwaarde: rate.geschatteMarktwaarde,
      gewensteHypotheek: rate.gewensteHypotheek,
      uniq: props.selectedRate.uniq,
      ltv: rate.ltv,
      rvp: {
        label: rate.label,
        interest: rate.interestValue,
      },
      discount: rate.discount,
      product_type: props.selectedRate.productType,
    }
    if (!event.target[3].value) {
      // PRD
      fetch(`${process.env.REACT_APP_SAM_URL}/api/contact`, {
        // ACC
        // fetch('https://acceptance.sam.solidbriq.nl/api/contact', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(contactObj),
      })
        .then(function (response) {
          return response.json()
        })
        .then(function (result) {
          setTimeout(() => {
            setFormLoading(false)
            props.submitted(props.intermediary)
          }, 1200)
        })
        .catch(function (error) {
          console.log('Request failed', error)
        })
    }
  }

  return (
    <div className="contact-form mt-4">
      <div className="text-lg">
        <hr />
        <h3 className="text-l font-bold mt-4">Uw selectie</h3>
        <ul className="max-w-md space-y-1  list-inside my-4">
          <li className="flex items-center mb-4">
            {props.selectedRate.productType === PRODUCT_TYPES.BASIQ && <img src={basiqBlueLogo} style={{ pointerEvents: 'none', height: '28px' }} alt="Basiq" />}
            {props.selectedRate.productType === PRODUCT_TYPES.BASIQ_SELECT && (
              <img src={basiqSelectBlueLogo} style={{ pointerEvents: 'none', height: '38px' }} alt="Basiq Select" />
            )}
            {props.selectedRate.productType === PRODUCT_TYPES.GENERIQ && <img src={generiqBlueLogo} style={{ pointerEvents: 'none', height: '28px' }} alt="Generiq" />}
            {props.selectedRate.productType === PRODUCT_TYPES.CLASSIQ && (
              <img src={classiqBlueLogo} style={{ pointerEvents: 'none', height: '28px' }} alt="Classiq" />
            )}
            {props.selectedRate.productType === PRODUCT_TYPES.CLASSIQ_SELECT && (
              <img src={classiqSelectBlueLogo} style={{ pointerEvents: 'none', height: '38px' }} alt="Classiq Select" />
            )}
          </li>
          <li className="flex items-center">
            <svg
              className="w-5 h-5 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {rate.interestValue.toLocaleString('nl-NL', { minimumFractionDigits: 2 }) + '%'} rente
          </li>
          <li className="flex items-center">
            <svg
              className="w-5 h-5 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {rate.label} vast
          </li>
          <li className="flex items-center">
            <svg
              className="w-5 h-5 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {parseInt(rate.gewensteHypotheek).toLocaleString('nl-NL', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 0,
            })}{' '}
            gewenste hypotheek
          </li>
          <li className="flex items-center">
            <svg
              className="w-5 h-5 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {parseInt(rate.geschatteMarktwaarde).toLocaleString('nl-NL', {
              style: 'currency',
              currency: 'EUR',
              minimumFractionDigits: 0,
            })}{' '}
            geschatte marktwaarde
          </li>
          <li className="flex items-center">
            <svg
              className="w-5 h-5 mr-1.5 text-green-500 dark:text-green-400 flex-shrink-0"
              fill="currentColor"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              ></path>
            </svg>
            {rate.ltv.toLocaleString('nl-NL', { minimumFractionDigits: 2 }) + '%'} LTV
          </li>
        </ul>
        <hr />
        <p className="my-6">Vul hieronder uw gegevens in.</p>
        <form
          onSubmit={handleSubmit}
          style={{ width: '100%', maxWidth: 640 }}
        >
          <input
            id="leadName"
            name="leadName"
            autoComplete="leadName"
            placeholder="Naam"
            disabled={formLoading}
            style={{ width: '100%' }}
            className="input-border-color h-12 mb-4 block px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
            required
          />
          <input
            id="leadEmail"
            name="leadEmail"
            autoComplete="leadEmail"
            placeholder="Email"
            disabled={formLoading}
            style={{ width: '100%' }}
            className="input-border-color h-12 mb-4 block px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
            required
          />
          <input
            id="leadPhone"
            name="leadPhone"
            autoComplete="leadPhone"
            disabled={formLoading}
            placeholder="Telefoon"
            style={{ width: '100%' }}
            className="input-border-color h-12 mb-8 block px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
            required
          />
          <input
            id="leadField"
            name="leadField"
            autoComplete="leadField"
            disabled={formLoading}
            placeholder="Lead Field"
            style={{ width: '100%' }}
            className="hidden input-border-color h-12 mb-8 px-3 border-0 border-b-4 border-primary-80 text-lg text-secondary-100 focus:border-primary-100 focus:ring-primary-100 focus-visible:ring-primary-100"
          />
          <button
            type="button"
            disabled={formLoading}
            onClick={() => props.cancel()}
            className="mr-2 py-3 px-5 border border-white font-medium  hover:bg-primary-80 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-light-blue-500"
          >
            Annuleer
          </button>
          <button
            type="submit"
            className="focus:outline-none  py-3 px-5 shadow-sm text-center text-white bg-secondary-100 hover:bg-primary-300 font-medium disabled:opacity-50 disabled:hover:bg-primary-100"
          >
            {formLoading && (
              <svg
                aria-hidden="true"
                role="status"
                className="inline mr-2 w-4 h-4 text-gray-200 animate-spin dark:text-gray-600"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                ></path>
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="#1C64F2"
                ></path>
              </svg>
            )}
            Verstuur
          </button>
        </form>
      </div>
    </div>
  )
}

export default ContactForm
